export default __webpack_public_path__ + "static/media/sherwin-Williams.73a7e0e0.png";